import EN from "./en.js";
import FR from "./fr.js";
const RESOURCES = {
  en: {
    translation: {
      ...EN,
    },
  },
  fr: {
    translation: {
      ...FR,
    },
  },
};
export default RESOURCES;
